<script setup>
import { defineProps, toRefs, defineEmits, defineExpose, inject } from 'vue';
import { useRoute } from "vue-router";
// import i18n from "@/i18n"
import Swal from "sweetalert2";
import { getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    formData: {
        type: Object,
        required: true,
        default: () => { }
    }
})
const currentTabLang = inject('currentTabLang') //切换语言
const emits = defineEmits(["update:formData"])
const { formData } = toRefs(props)
const route = useRoute()
// // 新增的模板字段  
const addTemplateInfoFields = () => {
    let m = {
        name: `${getLangValueByKey('product-template.template_text_field')}${formData.value.addfieldsList.length + 1}`,
        name_en: `${getLangValueByKey('product-template.template_text_field', 'en')}${formData.value.addfieldsList.length + 1}`,
        label: `${getLangValueByKey('product-template.template_text_field')}${formData.value.addfieldsList.length + 1}`,
        label_en: `${getLangValueByKey('product-template.template_text_field', 'en')}${formData.value.addfieldsList.length + 1}`,
        key: `filed-${formData.value.addfieldsList.length + 1}`,
        value: "",
        required: false,
        disabled: true,
        type: 1,
        extra: {
            type: 99,
        },
    }
    formData.value.addfieldsList.push(m)
    emits("update:formData", formData.value)
}
const editFields = (type, index) => {
    const { label, label_en, extra } = type == 0 ? formData.value.fieldsList[index] : formData.value.addfieldsList[index];
    // 增加一个数字信息的提示
    const keysList = ['product_info_base_info_inventory', 'product_info_base_info_batch_size', 'product_info_base_info_price', 'product_info_base_info_inventory_unit']; //注意其中product_info_base_info_inventory_unit 原来是单位现在改成了成本
    let isNumber = keysList.includes(formData.value.fieldsList[index].key);
    let extra_val = extra || { label: '', label_en: '', name: '', name_en: '' }
    // 两种效果 s数字输入框 暂时放开可以修改名字权限  李老师要求的 
    if (isNumber) {
        Swal.fire({
            title: currentTabLang.value == 1 ? getLangValueByKey("product-template.enterFieldName") : getLangValueByKey("product-template.enterFieldName", 'en'),
            html: `
            <span>${currentTabLang.value == 1 ? label : label_en}</span>
            <span style='color:#f06548;font-size: 12px'>${isNumber ? currentTabLang.value == 1 ? getLangValueByKey("base.is_number_input") : getLangValueByKey("base.is_number_input", 'en') : ''}</span>
            <input id="swal-input1" class="swal2-input my-1" style="width: 90%;" value="${currentTabLang.value == 1 ? label : label_en}">
            <input id="swal-input2" placeholder="${currentTabLang.value == 1 ? getLangValueByKey("product-template.unit_description") : getLangValueByKey("product-template", 'unit_description')}" class="swal2-input my-1" style="width: 90%;" value="${currentTabLang.value == 1 ? extra_val.label : extra_val.label_en}">
        `,
            focusConfirm: false,
             showCancelButton: true,
            confirmButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.done") : getLangValueByKey("base.done", 'en'),
            cancelButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.cancel") : getLangValueByKey("base.cancel", 'en'),
            confirmButtonColor: "#0AB39c",
            cancelButtonColor: "#f06548",
            preConfirm: () => {
                // return [
                //     document.getElementById("swal-input1").value,
                //     document.getElementById("swal-input2").value
                // ];
                let value1 = document.getElementById("swal-input1").value; // 名称
                let value2 = document.getElementById("swal-input2").value; // 名称 单位描述
                // 必须有 如果没有值就不修改
                if (value1 != '') {
                    // 验证   就不修改
                    if (currentTabLang.value == 1) {
                        formData.value.fieldsList[index].label = value1
                        formData.value.fieldsList[index].name = value1
                    } else {
                        formData.value.fieldsList[index].label_en = value1
                        formData.value.fieldsList[index].name_en = value1

                    }

                }
                // 单位不需要判断 是否必填
                if (currentTabLang.value == 1) {
                    // 判断是否存在extra
                    if (!formData.value.fieldsList[index].extra) {
                        formData.value.fieldsList[index].extra = { label: '', label_en: '', name: '', name_en: '' }
                    }
                    formData.value.fieldsList[index].extra.label = value2
                    formData.value.fieldsList[index].extra.name = value2
                } else {
                    // 判断是否存在extra
                    if (!formData.value.fieldsList[index].extra) {
                        formData.value.fieldsList[index].extra = { label: '', label_en: '', name: '', name_en: '' }
                    }
                    formData.value.fieldsList[index].extra.label_en = value2
                    formData.value.fieldsList[index].extra.name_en = value2

                }
                emits('update:formData', formData.value)
            }
        });
    } else {
        Swal.fire({
            title: currentTabLang.value == 1 ? getLangValueByKey("product-template.enterFieldName") : getLangValueByKey("product-template.enterFieldName", 'en'),
            input: "text",
            html: '',
            // text: isNumber ? currentTabLang.value == 1 ? getLangValueByKey("base.is_number_input"): getLangValueByKey("base.is_number_input", 'en') : '',
            inputValue: currentTabLang.value == 1 ? label : label_en, //currentTabLang.value == 1 ? label : label_en
            inputPlaceholder: currentTabLang.value == 1 ? getLangValueByKey("product-template.unit_description") : getLangValueByKey("product-template", 'unit_description'), // 修改为描述
            showCancelButton: true,
            confirmButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.done") : getLangValueByKey("base.done", 'en'),
            cancelButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.cancel") : getLangValueByKey("base.cancel", 'en'),
            showLoaderOnConfirm: true,
            confirmButtonColor: "#0AB39c",
            cancelButtonColor: "#f06548",
            inputValidator: (value) => {
                if (!value) {
                    return currentTabLang.value == 1 ? getLangValueByKey("product-template.requeiredInfo") : getLangValueByKey("product-template.requeiredInfo", 'en')
                }
            },
            preConfirm: (value) => {
                if (value) {
                    // 类型
                    if (type == 0) {
                        // 语言
                        if (currentTabLang.value == 1) {
                            formData.value.fieldsList[index].label = value
                            formData.value.fieldsList[index].name = value
                        } else {
                            formData.value.fieldsList[index].label_en = value
                            formData.value.fieldsList[index].name_en = value
                        }

                    } else {
                        // 自定义字段
                        // 语言
                        if (currentTabLang.value == 1) {
                            formData.value.addfieldsList[index].label = value
                            formData.value.addfieldsList[index].name = value
                        } else {
                            formData.value.addfieldsList[index].label_en = value
                            formData.value.addfieldsList[index].name_en = value
                        }
                    }
                    console.log(formData.value);
                    emits('update:formData', formData.value)
                }

            },
            allowOutsideClick: false,
        }).then((text) => {
            console.log(text);
        });
    }

}
const deleteFields = (type, index) => {
    Swal.fire({
        title: currentTabLang.value == 1 ? getLangValueByKey("base.delete_alert_title") : getLangValueByKey("base.delete_alert_title", 'en'),
        text: currentTabLang.value == 1 ? getLangValueByKey("base.delete_alert_info") : getLangValueByKey("base.delete_alert_info", 'en'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.done") : getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value == 1 ? getLangValueByKey("base.cancel") : getLangValueByKey("base.cancel", 'en'),
    }).then(async (result) => {
        if (result.isConfirmed) {
            if (type == 0) {
                formData.value.fieldsList[index].show = false
                // formData.value.fieldsList.splice(index, 1)
            } else {
                formData.value.addfieldsList.splice(index, 1)
            }
            emits("update:formData", formData.value)
        }
    });

}

const isCheckForm = inject('isCheckForm')

const checkForm = () => {
    isCheckForm.value = true
    let checkResult = true
    for (let k in formData.value.fieldsList) {
        if (formData.value.fieldsList[k].required && !formData.value.fieldsList[k].value) {
            checkResult = false
            break;
        }
    }
    console.log(checkResult);
    return checkResult;
}

defineExpose({
    checkForm,
})
</script>
<template>
    <b-card>
        <div class="row gy-3 w-100 py-2">
            <div
                style="font-weight: 500;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px; height: 40px; line-height: 40px;">
                {{ currentTabLang == 1 ? formData.title : formData.title_en }}
            </div>
            <div class="row  d-flex justify-content-start">
                <template v-for="(item, index) in formData.fieldsList" :key="index">
                    <div class="col-4 mt-2 " v-if="item.show">
                        <label class="form-label">
                            <span class="text-danger" v-if="item.required">*</span>
                            <span>{{ currentTabLang == 1 ? item.label : item.label_en }} {{ currentTabLang == 1 ?
                                item.extra?.label : item.extra?.label_en }}</span>
                            <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                                @click="editFields(0, index)"></i>
                        </label>
                        <div style="height: 40px;" class="d-flex align-items-center">
                            <!-- Checkbox Input -->
                            <div class="input-group">
                                <input clearable class="form-control" v-model="item.value" disabled />
                                <div class="input-group-text">
                                    <input class="form-check-input mt-0" type="checkbox"
                                        :disabled="route.query.type == 'view'" v-model="item.required"
                                        aria-label="Checkbox for following text input">
                                </div>
                            </div>
                            <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" v-if="route.query.type != 'view'"
                                style="color: #F06548; margin-left: 4px;" @click="deleteFields(0, index)"></i>
                        </div>
                    </div>
                </template>
                <!-- 新增字段部分 -->
                <div class="col-4 mt-2" v-for="(item, index) in formData.addfieldsList" :key="index">
                    <label class="form-label">
                        <span class="text-danger" v-if="item.required">*</span>
                        <span>{{ currentTabLang == 1 ? item.label : item.label_en }}</span>
                        <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                            @click="editFields(1, index)"></i>
                    </label>
                    <div class="d-flex align-items-center">
                        <!-- <input clearable type="number" maxlength="6" class="form-control"
                            style="display: inline; flex:1" disabled />
                        <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" style="color: #F06548; margin-left: 4px;"
                            @click="deleteFields(1, index)"></i> -->
                        <div class="input-group">
                            <input clearable class="form-control" v-model="item.value" disabled />
                            <div class="input-group-text">
                                <input class="form-check-input mt-0" type="checkbox"
                                    :disabled="route.query.type == 'view'" v-model="item.required"
                                    aria-label="Checkbox for following text input">
                            </div>
                        </div>
                        <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" v-if="route.query.type != 'view'"
                            style="color: #F06548; margin-left: 4px;" @click="deleteFields(1, index)"></i>
                    </div>
                </div>
            </div>

            <div style="text-align: center;">
                <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3"
                    @click="addTemplateInfoFields()" style="min-width: 120px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ currentTabLang == 1 ? getLangValueByKey("product-template.addField") :
                        getLangValueByKey("product-template.addField", 'en') }}
                </button>
            </div>
        </div>
    </b-card>
</template>
<style>
.swal2-html-container {
    /* font-size: 14px; */
    /* color: #f06548 !important; */
    /* text-align: left; */
    margin: .1em 1em .3em;
}

.swal2-input {
    margin: 0 1em;
}

.swal2-container .swal2-title {
    margin-bottom: 10px;
}
</style>